
export default function (value, limit) {
  return value.slice(0, limit)
}



// WEBPACK FOOTER //
// ./src/filters/limit.js